import { render, staticRenderFns } from "./ResellerClientTile.vue?vue&type=template&id=debd5f34&scoped=true&"
import script from "./ResellerClientTile.vue?vue&type=script&lang=js&"
export * from "./ResellerClientTile.vue?vue&type=script&lang=js&"
import style0 from "./ResellerClientTile.vue?vue&type=style&index=0&id=debd5f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debd5f34",
  null
  
)

export default component.exports